/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from "axios";
import { getCookieData, useApiRequest } from "../../helper/api";
import React, { useState, useEffect, useRef, useCallback } from "react";

import {
  createEditGoalsPayload,
  CreateMasterGoalPayload,
  GetDeleteEmployeeGoalAssessmentPayload,
  GetEmpGoalFinalAssessmentBymanagerPayload,
  GetEmpGoalFinalAssessmentBymanagerResponse,
  GetIPMSGoalResponse,
  MasterGoalsResponse,
} from "./ipmsmodel";
import { toast } from "react-toastify";
import {
  AssessmentPeriodPayload,
  AssessmentPeriodResponseModel,
  GetEmployeeGoalDataResponse,
  GetEmployeeGoalPayload,
  CreateUpdateGoalsPayload,
  GetEmpGoalAssessmentBymanagerPayload,
  GetEmpGoalAssessmentBymanager,
  GetEmployeeGoalAssessmentPayload,
  GetAssessmentStatusPayload,
  GetAssessmentStatusResponse,
  GetGoalAssessmentPayload,
  GetGoalsAssessmentsResponseData,
  SaveGoalAssessmentPayload,
  SaveGoalAssessmentByManagerResponse,
  SaveGoalAssessmentByHrResponse,
  ReportFilterMetadataResponse,
} from "./newipmsmodel";

const useIPMSApi = () => {
  const { fetchData } = useApiRequest();

  const userData = getCookieData("userData");
  const currentUser = userData ? JSON.parse(userData) : null;

  const fetchGetIpmsEmployeeData = async (
    payload: GetEmployeeGoalPayload
  ): Promise<GetEmployeeGoalDataResponse | null> => {
    const response: any = await fetchData("/performance/goals", {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const fetchGetIpmsAssessmentPeriods = async (
    payload: AssessmentPeriodPayload
  ): Promise<AssessmentPeriodResponseModel | null> => {
    try {
      const response = await fetchData("/performance/assessment_periods", {
        method: "POST",
        data: payload,
      });
      if (response?.status) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching assessment periods:", error);
    }
    return null;
  };

  const fetchGetIpmsEmployegoalAssessments = async (
    payload: GetAssessmentStatusPayload
  ): Promise<GetAssessmentStatusResponse[] | null> => {
    const response = await fetchData("/performance/get_assessment_status", {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const fetchGetIpmsEmployeGetgoalAssessment = async (
    payload: GetGoalAssessmentPayload
  ): Promise<GetGoalsAssessmentsResponseData | null> => {
    const response = await fetchData("/performance/assessments", {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const fetchGetIpmsGetEmpAssessmentByManager = async (
    payload: GetEmpGoalAssessmentBymanagerPayload
  ): Promise<GetEmpGoalAssessmentBymanager | null> => {
    const response = await fetchData("/performance/list", {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const fetchGetIpmsGetEmpFinalAssessmentview = async (
    payload: GetEmpGoalFinalAssessmentBymanagerPayload
  ): Promise<GetEmpGoalFinalAssessmentBymanagerResponse[] | null> => {
    const response = await fetchData("/ipms_goals/get_emp_assessment_by_hr", {
      method: "POST",
      data: payload,
    });
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const fetchGetIpmsGetEmpFinalAssessmentByManager = async (
    payload: GetEmpGoalAssessmentBymanagerPayload
  ): Promise<GetEmpGoalFinalAssessmentBymanagerResponse[] | null> => {
    const response = await fetchData(
      "/ipms_goals/get_emp_assesemnet_by_manager",
      {
        method: "POST",
        data: payload,
      }
    );
    if (response?.status) {
      return response.data;
    }
    return null;
  };

  const createupdateIpms = async (
    Payload: CreateUpdateGoalsPayload
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData("/performance/goals/save", {
      method: "POST",
      data: Payload,
    });
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const deleteGoalsIpms = async (Payload: {
    employee_id: number;
    assessment_year: number;
  }): Promise<AxiosResponse | null> => {
    const response = await fetchData("/performance/hr/delete-reviews", {
      method: "POST",
      data: Payload,
    });
    if (response?.status) {
      toast.success(
        response.data?.data?.message || "Reviews deleted successfully"
      );
    }
    return response?.data;
  };

  const rejectGoalsIpms = async (
    Payload: GetEmployeeGoalAssessmentPayload
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData("/performance/goals/status-update", {
      method: "POST",
      data: { ...Payload, approver_id: currentUser?.employee_id },
    });
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const approveEmployeeGoalsIpms = async (
    Payload: GetEmployeeGoalAssessmentPayload
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData("/performance/goals/status-update", {
      method: "POST",
      data: { ...Payload, approver_id: currentUser?.employee_id },
    });
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const updateGoalsAssessments = async (
    Payload: SaveGoalAssessmentPayload
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData("/performance/assessments/save", {
      method: "POST",
      data: Payload,
    });
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const updateGoalsAssessmentsByManager = async (
    Payload: SaveGoalAssessmentByManagerResponse
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData(
      "/performance/manager/assessments/save",
      {
        method: "POST",
        data: Payload,
      }
    );
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const updateGoalsAssessmentsByHr = async (
    Payload: SaveGoalAssessmentByHrResponse
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData("/performance/hr/assessments/save", {
      method: "POST",
      data: Payload,
    });
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const rejectGoalsAssessments = async (
    Payload: SaveGoalAssessmentPayload
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData("/performance/assessments/save", {
      method: "POST",
      data: Payload,
    });
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const CreateupdateGoals = async (
    Payload: CreateMasterGoalPayload,
    formType: string,
    goalID: number | null
  ): Promise<AxiosResponse | null> => {
    const response = await fetchData(
      `/performance/master-goals/${goalID ? goalID + "/" : ""}`,
      {
        method: formType === "create" ? "POST" : "PUT",
        data: Payload,
      }
    );
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const fetchGetIpmsGoalsData =
    async (): Promise<MasterGoalsResponse | null> => {
      const response = await fetchData("/performance/master-goals/", {
        method: "GET",
      });
      if (response?.status) {
        return response.data;
      }
      return null;
    };

  const deleteGoals = async (id: number): Promise<AxiosResponse | null> => {
    const response = await fetchData(`/performance/master-goals/${id}`, {
      method: "DELETE",
    });
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const fetchGetIpmsGetEmpAppriserList = async (Payload: {
    searchname: string;
  }): Promise<AxiosResponse | null> => {
    const response = await fetchData("/performance/get_appraiser_list", {
      method: "POST",
      data: Payload,
    });
    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const fetchGetIpmsGetEmpget_quarterAppriserList = async (Payload: {
    employee_id: number;
  }): Promise<any | null> => {
    const response = await fetchData(
      `/performance/manager/get_appraiser_data?employee_id=${Payload.employee_id}`,
      {
        method: "GET",
      }
    );

    if (response?.status) {
      toast.success(response.data);
    }
    return response?.data;
  };

  const saveChangeAppriser = async (
    employee_id: number,
    assessment_year: number,
    quarter_number: number,
    new_manager_id: number
  ): Promise<any | null> => {
    const response = await fetchData(
      `/performance/manager/change_appraiser?employee_id=${employee_id}&assessment_year=${assessment_year}&quarter_number=${quarter_number}&new_manager_id=${new_manager_id}`,
      { method: "POST" }
    );

    const res = response as any;
    const isBusinessSuccess =
      res?.status === true || res?.data?.status === true;
    const apiMessage = res?.data?.message || res?.message;

    if (isBusinessSuccess) {
      toast.success(apiMessage || "Appraiser updated successfully");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      toast.error(
        apiMessage || "Employee himself or herself cannot be appraiser"
      );
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }

    return res?.data || res;
  };

  const fetchIPMSReportList = async (Payload: {
    report_type?: string | null;
    status?: string | null;
    from_date?: string | null;
    to_date?: string | null;
    department?: number | null;
  }): Promise<ReportFilterMetadataResponse | null> => {
    const response = (await fetchData("/performance/reports/filter", {
      method: "POST",
      data: Payload,
    })) as ReportFilterMetadataResponse | undefined;
    if (response?.status) {
      return response;
    }
    return null;
  };

  const sendReminder = async (Payload: {
    reminders: {
      employee_id: number;
      name: string;
      report_type: string;
      quarter: number;
      year: number;
    }[];
  }): Promise<AxiosResponse | null> => {
    const response: any = await fetchData(
      "/performance/reports/filter/remind",
      {
        method: "POST",
        data: Payload,
      }
    );
    if (response?.status) {
      toast.success(
        response?.data?.message ||
          response?.message ||
          "Successfully queued reminder emails."
      );
    }
    return response as AxiosResponse;
  };

  const uploadAssessmentAttachment = async (
  reviewId: number,
  formData: FormData
): Promise<any> => {
  try {
    console.log("[uploadAssessmentAttachment] Starting upload for review:", reviewId);
    
    // ? FIXED: Include review_id as query parameter
    const response: any = await fetchData(
      `/performance/attachments/upload?review_id=${reviewId}`,
      {
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    
    console.log("[uploadAssessmentAttachment] Response:", response);
    
    // if (response?.status) {
    //   toast.success(response?.data?.message || "File uploaded successfully");
    // } else {
    //   toast.error(response?.message || "Upload failed");
    // }
    
    return response;
  } catch (error: any) {
    console.error("[uploadAssessmentAttachment] Error:", error);
    const errorMsg = error?.response?.data?.detail || error?.message || "Upload failed";
    toast.error(errorMsg);
    throw error;
  }
};
 
/**
 * ? FIXED: Fetch attachments for a review
 */
const fetchAttachments = async (reviewId: number): Promise<any> => {
  try {
    console.log("[fetchAttachments] Fetching for review:", reviewId);
    
    const response: any = await fetchData(
      `/performance/reviews/${reviewId}/attachments`,
      {
        method: "GET",
      }
    );
    
    console.log("[fetchAttachments] Response:", response);
    return response;
  } catch (error: any) {
    console.error("[fetchAttachments] Error:", error);
    return { status: false, data: { attachments: [] } };
  }
};
 
/**
 * ? FIXED: Delete an attachment
 */
const deleteAttachment = async (attachmentId: number): Promise<any> => {
  try {
    console.log("[deleteAttachment] Deleting attachment:", attachmentId);
    
    const response: any = await fetchData(
      `/performance/attachments/${attachmentId}`,
      {
        method: "DELETE",
      }
    );
    
    console.log("[deleteAttachment] Response:", response);
    
    // if (response?.status) {
    //   toast.success("File deleted successfully");
    // } else {
    //   toast.error(response?.message || "Delete failed");
    // }
    
    return response;
  } catch (error: any) {
    console.error("[deleteAttachment] Error:", error);
    const errorMsg = error?.response?.data?.detail || error?.message || "Delete failed";
    toast.error(errorMsg);
    throw error;
  }
};

const downloadAssessmentAttachment = async (
  reviewId: number,
  fileName?: string
): Promise<any> => {
  try {
    console.log("[downloadAssessmentAttachment] Fetching for attachment:", reviewId, fileName);
    
    // 1. Used backticks string template interpolation (${attachmentId})
    const response: any = await fetchData(
      `/performance/attachments/${reviewId}/download`, 
      {
        method: "GET",
        responseType: "blob",
      }
    );
    
    console.log("[downloadAssessmentAttachment] Response:", response);
    return response;
  } catch (error: any) {
    console.error("[downloadAssessmentAttachment] Error:", error);
    return { status: false, data: { attachments: [] } };
  }
};

  return {
    fetchGetIpmsEmployeeData,
    createupdateIpms,
    rejectGoalsIpms,
    deleteGoalsIpms,
    fetchGetIpmsAssessmentPeriods,
    fetchGetIpmsEmployegoalAssessments,
    fetchGetIpmsEmployeGetgoalAssessment,
    updateGoalsAssessments,
    fetchGetIpmsGetEmpAssessmentByManager,
    CreateupdateGoals,
    fetchGetIpmsGoalsData,
    deleteGoals,
    approveEmployeeGoalsIpms,
    updateGoalsAssessmentsByManager,
    updateGoalsAssessmentsByHr,
    fetchGetIpmsGetEmpFinalAssessmentByManager,
    fetchGetIpmsGetEmpFinalAssessmentview,
    fetchGetIpmsGetEmpAppriserList,
    fetchGetIpmsGetEmpget_quarterAppriserList,
    saveChangeAppriser,
    fetchIPMSReportList,
    sendReminder,
    rejectGoalsAssessments,
    fetchAttachments,
    uploadAssessmentAttachment,
    deleteAttachment,
    downloadAssessmentAttachment,
  };
};

export default useIPMSApi;
